import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ConnectionService } from '../services/connection.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const conn = inject(ConnectionService);

  if (auth.isLoggedIn()) return true;
  if (auth.isGuest() && conn.mode() === 'lan' && !!conn.lanIp()) return true;

  router.navigate(['/dashboard']);
  return false;
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return true;

  router.navigate(['/dashboard']);
  return false;
};

export const cloudOnlyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isGuest()) return true;

  router.navigate(['/dashboard/settings']);
  return false;
};
